import { getProductRoute as coreGetProductRoute } from '@shopware/helpers';

interface SomeProductThingy {
    id: string;
    seoUrls?: Array<{
        seoPathInfo?: string;
    }>;
}

export default function getProductRoute(product: SomeProductThingy, customLocale?: string): RouteObject {
    const route = coreGetProductRoute(product);

    // for async product routes
    if (customLocale) {
        route.path = `/${customLocale}/shop${route.path}`;
        return route;
    }

    const { urlSegment } = useLanguage();
    route.path = `/${urlSegment.value}/shop${route.path}`;

    return route;
}
